@switch (routeLayoutData().leftBanner) {
  @case ('intervu') {
    <div class="min-h-screen w-full bg-background-blue py-11 flex flex-col gap-7">
      <img
        src="assets/Forsta_InterVu_Germany_RGB_Navy_Horizontal.svg"
        alt="Forsta InterVu logo"
        width="220px"
        height="70px"
        class="ml-3"
      />
      <div class="font-sans px-8 mt-16 flex flex-col gap-5">
        <h2 class="font-bold text-xl">
          Full-service online focus groups.<br />
          With tools built for the task.
        </h2>
        <p class="text-base">
          Includes pro research tools like polling,<br />
          file sharing with markup, backroom and <br />
          fully supports 8+ languages.
        </p>
        <p class="text-base">
          Add accurate verbatim time-stamped<br />
          Human transcripts to your research for<br />
          $135 an hour.
        </p>
      </div>
      <div class="relative">
        <img
          class="object-fill px-8 py-14 bg-background-blue"
          src="assets/intervu-banner-add.webp"
          alt="Forsta InterVu banner add"
        />
      </div>
    </div>
  }
  @case ('vision') {
    <div class="flex flex-col relative h-full w-full bg-primary">
      <img class="w-48 ml-8 pt-12 mb-8" src="assets/Forsta_Vision_RGB_White_Horizontal.svg" alt="Forsta Vision logo" />
      <div class="flex flex-col text-white mx-12 font-sans my-2 text-base; lg:tw:text-lg">
        <div class="bg-white h-1 w-16 mb-8"></div>
        <p class="text-xl font-light text-white">
          Add secured and data protected online video to your in-person focus groups.
        </p>
        <br />
        <p class="text-xl font-light text-white">
          With the highest quality stream observers can be in the room, wherever they may be.
        </p>
        <br />
        <p class="text-xl font-light text-white">
          Add accurate verbatim time-stamped Human transcripts to your research for $135 an hour.
        </p>
      </div>
      <div class="flex flex-col absolute bottom-0 w-full px-16 invisible 2xl:visible short:invisible">
        <div class="bg-secondary h-28"></div>
        <div class="bg-secondary h-24 w-28 place-self-end"></div>
      </div>
    </div>
  }
  @case ('dashboard') {
    <div
    class="flex flex-col relative h-full w-full bg-primary short:overflow-y-hidden"
    style="
      background-image: url('assets/banner_default_dashboard.webp');
      background-size: cover;
      background-position: center;
    "
  >
    <img
      src="../../assets/Forsta_Logo_Magenta_&_White_RGB_with_Germany_Tagline.svg"
      alt="forsta-logo"
      height="50px"
      width="144.67px"
      class="max-h-[50px] mt-6 ml-8"
    />
    <div class="flex flex-col text-white mx-12 font-sans my-2">
      <p class="text-3xl font-medium text-secondary 2xl:text-5xl">Forsta InterVu</p>
      <br />
      <p class="text-xl font-medium text-white 2xl:text-3xl">
        Online focus groups<br />
        have never been easier
      </p>
      <br />
      <a
        href="https://www.forsta.com/platform/digital-interviews/"
        class="w-1/2 btn btn-outline bg-accent-blue text-primary border-accent-blue hover:bg-primary hover:text-accent-blue hover:border-accent-primary"
        >Request a demo</a
      >
    </div>
  </div>
  }
}
